import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "navbar-x",
    style: {
      backgroundColor: _vm.formData.bgColor
    }
  }, [_c("div", {
    staticClass: "header_box"
  }, [_c("div", [_c("div", [_c("div", {
    class: ["header", {
      top: _vm.top_visible
    }]
  }, [_c("div", {
    staticClass: "header_top common_content",
    style: {
      backgroundColor: _vm.formData.bgColor,
      paddingTop: _vm.formData.pcPaddingTop + "px",
      paddingBottom: _vm.formData.pcPaddingBottom + "px"
    }
  }, [_c("div", {
    staticClass: "header_top_left"
  }, [_vm.formData.logo ? _c("a", {
    style: {
      opacity: _vm.formData.logo ? 1 : 0,
      pointerEvents: _vm.formData.logo ? "auto" : "none"
    }
  }, [_vm.imgHost ? _c("YYImage", {
    key: "h_logo",
    staticClass: "logo",
    style: {
      width: _vm.formData.logoWidth + "px"
    },
    attrs: {
      src: _vm.imgHost + _vm.formData.logoPath
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.formData.lang ? _c("div", {
    directives: [{
      name: "hmclickoutside",
      rawName: "v-hmclickoutside:js-languages",
      value: function value() {
        return _vm.languages_visible = false;
      },
      expression: "() => (languages_visible = false)",
      arg: "js-languages"
    }],
    staticClass: "languages",
    style: {
      marginLeft: _vm.formData.logo ? "50px" : "0"
    }
  }, [_vm.languages && _vm.languageName ? _c("div", {
    ref: "languages",
    staticClass: "lang_tag",
    style: {
      opacity: _vm.formData.lang ? 1 : 0,
      pointerEvents: _vm.formData.lang ? "auto" : "none",
      color: _vm.formData.textColor
    },
    on: {
      mouseenter: function mouseenter($event) {
        return _vm.handleHoverColorEnter(_vm._self, "languages", _vm.formData.hoverTextColor);
      },
      mouseleave: function mouseleave($event) {
        return _vm.handleHoverColorLeave(_vm._self, "languages");
      },
      click: function click($event) {
        _vm.languages_visible = !_vm.languages_visible;
      }
    }
  }, [_c("i", {
    staticClass: "yy-icon--Universe"
  }), _c("span", [_vm._v(_vm._s(_vm.languageName))]), _c("i", {
    staticClass: "yy-icon-ArrowDown1"
  })]) : _vm._e(), _c("dd", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.languages_visible,
      expression: "languages_visible"
    }],
    staticClass: "languages_list js-languages"
  }, _vm._l(_vm.languages, function (item, key) {
    return _c("dl", {
      key: "languages_" + key,
      ref: "langListItem",
      refInFor: true,
      style: {
        color: _vm.formData.textColor
      },
      attrs: {
        "data-value": item.langId
      },
      on: {
        click: function click($event) {
          return _vm.languageChang(item);
        },
        mouseenter: function mouseenter($event) {
          return _vm.handleItemEnter("langListItem", key);
        },
        mouseleave: function mouseleave($event) {
          return _vm.handleItemLeave("langListItem", key);
        }
      }
    }, [_vm._v(" " + _vm._s(item.langTitle) + " ")]);
  }), 0)]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.top_visible,
      expression: "top_visible"
    }],
    ref: "all_product2",
    staticClass: "productClassify",
    on: {
      click: function click($event) {
        return _vm.showHideCategories();
      }
    }
  }, [_c("i", {
    staticClass: "yy-icon-Access"
  }), _c("span", [_vm._v(_vm._s(_vm.$t("header.allProduct")))]), _c("i", {
    staticClass: "yy-icon-ArrowDown1"
  })])]), _c("div", {
    staticClass: "header_top_right"
  }, [_vm.formData.search ? _c("i", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.text_search_visible,
      expression: "!text_search_visible"
    }],
    ref: "search_icon",
    staticClass: "yy-icon-Search2",
    style: {
      opacity: _vm.formData.search ? 1 : 0,
      pointerEvents: _vm.formData.search ? "auto" : "none",
      color: _vm.formData.textColor
    },
    on: {
      mouseenter: function mouseenter($event) {
        return _vm.handleHoverColorEnter(_vm._self, "search_icon", _vm.formData.hoverTextColor);
      },
      mouseleave: function mouseleave($event) {
        return _vm.handleHoverColorLeave(_vm._self, "search_icon");
      },
      click: function click($event) {
        return _vm.clickSearchBtn();
      }
    }
  }) : _vm._e(), _vm.formData.search ? [_vm.text_search_visible ? _c("div", {
    directives: [{
      name: "hmclickoutside",
      rawName: "v-hmclickoutside",
      value: function value() {
        return _vm.searchDialogStatus = false;
      },
      expression: "() => searchDialogStatus = false"
    }],
    ref: "search_box",
    staticStyle: {
      display: "inline-block",
      position: "relative"
    },
    style: {
      opacity: _vm.formData.search ? 1 : 0,
      pointerEvents: _vm.formData.search ? "auto" : "none",
      color: _vm.formData.textColor,
      "--navbarHoverTextColor": _vm.formData.hoverTextColor
    }
  }, [_c("YYInput", {
    ref: "search",
    staticClass: "input_search",
    attrs: {
      placeholder: _vm.$t("header.searchPlaceholder"),
      clearable: true
    },
    on: {
      focus: _vm.searchInputFocus
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return $event.target.blur.apply(null, arguments);
      }
    },
    model: {
      value: _vm.text_search,
      callback: function callback($$v) {
        _vm.text_search = $$v;
      },
      expression: "text_search"
    }
  }), _c("a", {
    attrs: {
      to: {
        name: "productlist",
        query: {
          search: _vm.text_search,
          orderType: 1,
          page: 1
        }
      }
    }
  }, [_c("i", {
    staticClass: "yy-icon-Search iconInputSearch",
    style: {
      backgroundColor: _vm.formData.hoverTextColor
    },
    on: {
      click: function click($event) {
        return _vm.search(_vm.text_search);
      }
    }
  })]), _vm.searchDialogStatus ? _c("div", {
    ref: "searchDialog",
    staticClass: "searchDialog"
  }, [_vm.searchHistoryList.length > 0 ? [_c("div", {
    staticClass: "title",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between"
    },
    style: {
      color: _vm.formData.textColor
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("header.searchHistory")))]), _c("div", {
    staticClass: "deleteSearchHistoryList",
    style: {
      color: _vm.formData.textColor
    },
    on: {
      click: _vm.deleteSearchHistoryList
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("header.empty")) + " ")])]), _c("div", {
    staticClass: "searchHistory"
  }, [_vm._l(_vm.searchHistoryList, function (item, index) {
    return [_c("div", {
      staticClass: "historyArea"
    }, [_c("div", {
      staticClass: "delete",
      staticStyle: {
        display: "flex",
        "justify-content": "center",
        "align-items": "center"
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.deleteSearchHistory(index);
        }
      }
    }, [_c("i", {
      staticClass: "yy-icon-Delete",
      staticStyle: {
        "font-size": "16px"
      }
    })]), _c("a", {
      attrs: {
        to: {
          name: "productlist",
          query: {
            search: item,
            orderType: 1,
            page: 1
          }
        }
      }
    }, [_c("div", {
      ref: "historyItem",
      refInFor: true,
      staticClass: "keyword",
      staticStyle: {
        position: "relative"
      },
      style: {
        color: _vm.formData.textColor
      },
      on: {
        click: function click($event) {
          return _vm.search(item);
        },
        mouseenter: function mouseenter($event) {
          return _vm.handleSearchItemEnter("historyItem", index);
        },
        mouseleave: function mouseleave($event) {
          return _vm.handleSearchItemLeave("historyItem", index);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")])])])];
  })], 2)] : _vm._e(), _c("div", {
    staticClass: "title",
    style: {
      color: _vm.formData.textColor
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("header.hotRecommend")) + " ")]), _vm.hotWordList.length ? _c("div", {
    staticClass: "keywordContent"
  }, [_vm._l(_vm.hotWordList, function (item, index) {
    return [_c("a", {
      style: {
        color: _vm.formData.textColor
      },
      attrs: {
        to: {
          name: "productlist",
          query: {
            search: item.keywordName,
            orderType: 1,
            page: 1
          }
        }
      }
    }, [_c("div", {
      key: "hotWordList" + index,
      ref: "keywordItem",
      refInFor: true,
      staticClass: "keyword",
      on: {
        click: function click($event) {
          return _vm.search(item.keywordName);
        },
        mouseenter: function mouseenter($event) {
          return _vm.handleSearchItemEnter("keywordItem", index);
        },
        mouseleave: function mouseleave($event) {
          return _vm.handleSearchItemLeave("keywordItem", index);
        }
      }
    }, [_vm._v(" " + _vm._s(item.keywordName) + " ")])])];
  })], 2) : _vm._e()], 2) : _vm._e()], 1) : _vm._e()] : _vm._e(), _vm.formData.account ? _c("i", {
    ref: "user_menu",
    staticClass: "yy-icon-User1",
    style: {
      opacity: _vm.formData.account ? 1 : 0,
      pointerEvents: _vm.formData.account ? "auto" : "none",
      color: _vm.formData.textColor
    },
    on: {
      mouseenter: function mouseenter($event) {
        return _vm.handleHoverColorEnter(_vm._self, "user_menu", _vm.formData.hoverTextColor);
      },
      mouseleave: function mouseleave($event) {
        return _vm.handleHoverColorLeave(_vm._self, "user_menu");
      },
      click: function click($event) {
        return _vm.clickIconUser();
      }
    }
  }) : _vm._e(), _c("a", [_vm.formData.shopcart ? _c("i", {
    ref: "cartIcon",
    staticClass: "yy-icon-ShoppingCart shoppingCart",
    style: {
      opacity: _vm.formData.shopcart ? 1 : 0,
      pointerEvents: _vm.formData.shopcart ? "auto" : "none",
      color: _vm.formData.textColor
    },
    on: {
      mouseenter: function mouseenter($event) {
        return _vm.handleHoverColorEnter(_vm._self, "cartIcon", _vm.formData.hoverTextColor);
      },
      mouseleave: function mouseleave($event) {
        return _vm.handleHoverColorLeave(_vm._self, "cartIcon");
      }
    }
  }, [_vm.shopcartNum > 0 ? _c("sup", {
    staticClass: "el-badge__content el-badge__content--primary is-fixed"
  }, [_vm._v(_vm._s(_vm.shopcartNum))]) : _vm._e()]) : _vm._e()])], 2)])])])])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };